<template>
  <tbody>
    <slot />
  </tbody>
</template>

<script>
export default {
  name: 'dx-tbody',
};
</script>

<style scoped lang="scss">
:slotted(tr) {
  border-bottom: 1px solid #dddddd;
  font-size: var(--dx-text-size--sm);

  &:nth-of-type(even) {
    background: var(--dx-color--grey-light);
  }

  &:last-of-type {
    border-bottom: 2px solid var(--dx-color--blue-semi-light);
  }
}
</style>
